import React from 'react';
import { Box, Button, Heading, HStack, useBreakpointValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { PrivacyPolicyContent } from 'clipsal-cortex-ui/src/components/PrivacyPolicyContent';

import { BOTTOM_NAV_HEIGHT } from '../constants';
import { MobileTopNav } from './MobileTopNav';

export const PrivacyPolicy = () => {
  const isMobileViewport = useBreakpointValue({ base: true, xl: false }, { ssr: false });
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <Box pb={BOTTOM_NAV_HEIGHT}>
      {isMobileViewport ? (
        <MobileTopNav title={'Privacy Policy'} onGoBack={handleGoBack} />
      ) : (
        <HStack w="100%" justifyContent="space-between" p={4} mb={4}>
          <Button onClick={handleGoBack} mt={3}>
            Back
          </Button>
          <Heading as="h5" size="lg" mt={4}>
            Privacy Policy
          </Heading>
          <Box />
        </HStack>
      )}
      <Box p={4} data-testid="privacy-policy-content">
        <PrivacyPolicyContent />
      </Box>
    </Box>
  );
};
